import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { route } from "./routes";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import axios from "axios";
import qs from "qs";
import i18n from "./i18n";
import { Routes, Route } from "react-router-dom";
import {
  withStyleguide,
  withError,
  withCoursePortalApi,
  withCourseGroupsApi,
  Loading,
  FormUtility,
  withRouter,
  GelContentContainer,
  NotFound
} from "cw-styleguide-react";
import Helmet from 'react-helmet';
import SearchController from "./routes/search/controllers/SearchController";
import ResultsController from "./routes/results/controllers/ResultsController";
import DetailController from "./routes/details/controllers/DetailController";
import NotFoundController from "./routes/notFound/controllers/NotFoundController";

class App extends Component {
  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      query: "",
      loaded: false,
    };

    this.loadFilters = this.loadFilters.bind(this);
    this.setQuery = this.setQuery.bind(this);
    this.resetQuery = this.resetQuery.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.styleguide.setLanguageUrl(
      route(
        "courseSearch",
        null,
        this.props.i18n.language === "en" ? "cy" : "en"
      ).substr(1)
    );
    this.loadFilters();
  }

  /**
   * loadFilters
   */
  loadFilters() {
    Promise.all([
      axios.get(
        this.props.coursePortalApiGetEndpoint(
          "course_portal_api_course_filters"
        ),
        {
          headers: {
            "Accept-Language": i18n.language, // @todo change back to i18n when welsh is available
          },
        }
      ),
      axios.get(
        this.props.courseGroupsApiGetEndpoint(
          "course_groups_api_course_groups_filters"
        ),
        {
          headers: {
            "Accept-Language": i18n.language, // @todo change back to i18n when welsh is available
          },
        }
      ),
    ])
      .then(async ([response1, response2]) => {
        let filters = this.state.filters;

        filters.qualificationUnknown = response1.data.qualificationUnknown;
        filters.languageLookup = response1.data.languages;
        filters.programmeLookup = response1.data.programme;
        filters.qualificationTypeLookup = response1.data.qualificationType;
        filters.qualificationType = Object.keys(
          response1.data.qualificationType
        ).map((id) => ({
          value: id,
          label: response1.data.qualificationType[id],
        }));
        filters.proximity = Object.keys(response1.data.proximity).map((id) => ({
          value: id,
          label: response1.data.proximity[id],
        }));
        filters.programme = Object.keys(response1.data.programme).map((id) => ({
          value: id,
          label: response1.data.programme[id]["name"],
        }));
        filters.courseTypeLookup = response1.data.courseType;
        filters.courseType = Object.keys(response1.data.courseType).map(
          (id) => ({
            value: id,
            label: response1.data.courseType[id],
          })
        );
        filters.courseGroupTypeLookup = response2.data.courseGroupType;
        filters.courseGroupType = Object.keys(
          response2.data.courseGroupType
        ).map((id) => ({
          value: id,
          label: response2.data.courseGroupType[id],
        }));
        filters.studyMethodTimesLookup = response1.data.studyMethodTimes;
        filters.studyMethodTimes = Object.keys(
          response1.data.studyMethodTimes
        ).map((id) => ({
          value: id,
          label: response1.data.studyMethodTimes[id],
        }));
        filters.studyMethodHoursLookup = response1.data.studyMethodHours;
        filters.studyMethodHours = Object.keys(
          response1.data.studyMethodHours
        ).map((id) => ({
          value: id,
          label: response1.data.studyMethodHours[id],
        }));
        filters.studyMethodTypeLookup = response1.data.studyMethodType;
        filters.studyMethodType = Object.keys(
          response1.data.studyMethodType
        ).map((id) => ({
          value: id,
          label: response1.data.studyMethodType[id],
        }));
        filters.awardingBodyLookup = response1.data.awardingBody;
        filters.awardingBody = Object.keys(response1.data.awardingBody).map(
          (id) => ({
            value: id,
            label: response1.data.awardingBody[id],
          })
        );
        filters.facilitiesAvailableLookup = response1.data.facilitiesAvailable;
        filters.learnerSupportLookup = response1.data.learnerSupport;
        filters.qualificationLevelLookup = response1.data.qualificationLevel;

        this.setState({
          filters: filters,
          loaded: true,
        });
      })
      .catch((error) => {
        console.error(error);

        let errors = FormUtility.processServerErrors(error, i18n);

        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          loaded: false,
        });
      });
  }

  /**
   * convertFiltersToParameters
   * @param filters
   * @returns {string}
   */
  convertFiltersToParameters(filters) {
    let params = {
      courseId: filters.courseId,
      courseTitle: filters.courseTitle,
      keyword: filters.keyword,
      location: filters.location,
      proximity: filters.proximity,
      qualificationType:
        filters.qualificationType instanceof Set
          ? Array.from(filters.qualificationType)
          : [filters.qualificationType],
      studyMethodType:
        filters.studyMethodType instanceof Set
          ? Array.from(filters.studyMethodType)
          : [filters.studyMethodType],
      studyMethodHours:
        filters.studyMethodHours instanceof Set
          ? Array.from(filters.studyMethodHours)
          : [filters.studyMethodHours],
      studyMethodTimes:
        filters.studyMethodTimes instanceof Set
          ? Array.from(filters.studyMethodTimes)
          : [filters.studyMethodTimes],
      mainProviderId: filters.mainProviderId,
      mainProviderLabel: filters.mainProviderLabel,
      programme:
        filters.programme instanceof Set
          ? Array.from(filters.programme)
          : [filters.programme],
      courseType:
        filters.courseType instanceof Set
          ? Array.from(filters.courseType)
          : [filters.courseType],
      courseGroupType:
        filters.courseGroupType instanceof Set
          ? Array.from(filters.courseGroupType)
          : [filters.courseGroupType],
      order: filters.order,
      groupSize: filters.groupSize,
      page: filters.page,
    };

    // Remove empty filter parameters.
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key].length === 0) {
        delete params[key];
      }
    });

    return qs.stringify(params, {
      addQueryPrefix: true,
      arrayFormat: "brackets",
    });
  }

  /**
   * convertParametersToFilters
   * @param parameters
   * @returns {any}
   */
  convertParametersToFilters(parameters) {
    const params = qs.parse(parameters, { ignoreQueryPrefix: true });

    // Remove empty parameter filters.
    Object.keys(params).forEach((key) => {
      params[key] = Array.isArray(params[key])
        ? new Set(params[key])
        : params[key];
      if (!params[key] || params[key].length === 0) {
        delete params[key];
      }
    });

    return params;
  }

  /**
   * setQuery
   * @param value
   */
  setQuery(value) {
    this.setState({
      query: value,
    });
  }

  /**
   * resetQuery
   */
  resetQuery() {
    this.setState({
      query: "",
    });
  }

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {
    if (!this.state.loaded) {
      return <Loading text={this.props.t("styleguide:forms.loading")} />;
    }

    return (
      <Fragment>
        <Helmet>
          {/* Adding meta description tag for #11947 */}
          {/* https://dev.azure.com/ccdg/CWO%20-%20SEO/_workitems/edit/11947 */}
          <meta name="description" content={this.props.t("app.description")} />
        </Helmet>

        <BreadcrumbsItem to={route("courseSearch")}>
          {this.props.t("view.search.breadcrumb")}
        </BreadcrumbsItem>

        <Routes>
          <Route
            path={route("courseSearch")}
            exact={true}
            element={
              <SearchController
                {...this.props}
                {...this.state}
                convertFiltersToParameters={this.convertFiltersToParameters}
                setQuery={this.setQuery}
                resetQuery={this.resetQuery}
              />
            }
          />

          <Route
            path={route("results")}
            exact={true}
            element={
              <ResultsController
                {...this.props}
                {...this.state}
                convertFiltersToParameters={this.convertFiltersToParameters}
                convertParametersToFilters={this.convertParametersToFilters}
                setQuery={this.setQuery}
                resetQuery={this.resetQuery}
              />
            }
          />
          <Route
            path={route("detail")}
            element={<DetailController {...this.props} {...this.state} />}
          />

          <Route
            path="*"
            element={
              <GelContentContainer>
                <NotFound />
              </GelContentContainer>
            }
          />
        </Routes>
      </Fragment>
    );
  }
}

export default withCoursePortalApi(process.env)(
  withCourseGroupsApi(process.env)(
    withError(withRouter(withStyleguide(withTranslation("local")(App))))
  )
);
